let isAnimating = false;

//open first accordion items on load. can't hard code this since its in a cms, der.
$('.single-accordion:first-of-type .accordion-content').addClass('current');
$('.single-accordion:first-of-type .accordion-header .state').addClass('active');

$('.single-accordion .accordion-header').on('click', function(e) {
    //limiting scope of interaction to just one carousel when more than one carousels are on the page.
    var $curAccord = $(this).parent().parent();
    if (!isAnimating) {
        isAnimating = true;
        if ($(this).next().hasClass('current')) {
            $curAccord.find('.single-accordion .accordion-header .state').removeClass('active');
            $(this).next().removeClass('current').slideUp(function() {
                isAnimating = false;
            });
        } else {
            $curAccord.find('.single-accordion .accordion-content').slideUp().removeClass('current');
            $curAccord.find('.single-accordion .accordion-header .state').removeClass('active');
            $(this).next().addClass('current').slideToggle(function() {
                isAnimating = false;
            });
            $(this).find('.state').addClass('active');
        }
    }
});